<div class="app-container fill" [ngClass]="{ 'bg-dark-2': account }">
  <div class="main-content-container">
    <!-- main nav -->
    @if (account && showNavBar) {
      <nav class="navbar navbar-expand sticky-top navbar-dark bg-dark">
        <div class="container">
          <div class="navbar-nav">
            <a routerLink="/" [routerLinkActiveOptions]="{exact: true}">
              <img alt="Logo" src="/assets/logos/TESSELLON-LOGO-WHITE.svg" class="center-div"
                style="width: 125px; height: 50px;" />
              </a>
              <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="nav-item nav-link" style="padding-left: 25px">Home</a>
              <a routerLink="/profile" routerLinkActive="active" class="nav-item nav-link">Profile</a>
              @if (account.roles.includes(Role.Admin)) {
                <a routerLink="/admin" routerLinkActive="active"
                class="nav-item nav-link">Admin</a>
              }
              <a (click)="logout()" class="nav-item nav-link">Logout</a>
            </div>
          </div>
        </nav>
      }

      <!-- subnav router outlet -->
      <router-outlet name="subnav"></router-outlet>

      <!-- global alert -->
      <alert></alert>

      <!-- main router outlet -->
      <router-outlet></router-outlet>
    </div>
  </div>